var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:[
    'surface-section-title-new',
    'relative',
    'rounded-xl',
    'text-20',
    'break-words',
    {
      'bg-dark-ui-100 text-light-text-100': _vm.colorScheme === 'dark',
      'bg-light-ui-100 text-dark-text-100': _vm.colorScheme === 'light',
    },
    'font-semibold',
    'mb-4',
    'w-[254px]',
    _vm.tailwindFontClass ],attrs:{"data-view-mode":_vm.isBeingEdited ? 'edit' : 'show'},on:{"dblclick":_vm.tryStartEditing}},[_c('div',{staticClass:"ltr:pl-3 rtl:pr-3 ltr:pr-4 rtl:pl-4 py-2"},[(!_vm.isBeingEdited)?_c('hgroup',[_c('h2',{attrs:{"data-cy":"sectionTitle"}},[_vm._v(_vm._s(_vm.sectionTitle))])]):_vm._e(),_vm._v(" "),(_vm.isBeingEdited)?_c('hgroup',[_c('multiline-input',{ref:"title",class:[
          _vm.tailwindFontClass,
          'text-20',
          {
            'bg-dark-ui-100 text-light-text-100 placeholder-light-text-200': _vm.colorScheme === 'dark',
            'bg-light-ui-100 text-dark-text-100 placeholder-dark-text-200': _vm.colorScheme === 'light',
          },
          ,
          'font-semibold',
          'm-0' ],attrs:{"dir":_vm.dir,"value":_vm.sectionTitle,"maxlength":_vm.maxLength,"placeholder":_vm.titlePlaceholder,"required":""},on:{"enter":_vm.saveTitle,"escape":_vm.stopEditingSection},nativeOn:{"paste":function($event){$event.stopPropagation();}}})],1):_vm._e()]),_vm._v(" "),(_vm.isBeingEdited)?_c('div',{staticClass:"flex w-full justify-end h-8"},[(!_vm.isEmptyState)?_c('OzTextButton',{class:['font-semibold', 'text-14', 'me-4'],attrs:{"color-scheme":_vm.OzTextButtonColorScheme.Secondary,"dark-mode":_vm.colorScheme === 'dark',"text":_vm.__('Cancel')},on:{"click":_vm.stopEditingSection}}):_vm._e(),_vm._v(" "),_c('OzTextButton',{class:['font-semibold', 'text-14', 'me-4'],attrs:{"dark-mode":_vm.colorScheme === 'dark',"text":_vm.__('Save')},on:{"click":_vm.saveTitle}})],1):_vm._e(),_vm._v(" "),(_vm.canIModerate && !_vm.isBeingEdited)?_c('OzTextButton',{class:[
      'absolute',
      'leading-none',
      'p-0',
      'w-[32px]',
      'h-[32px]',
      // Assume 3 dots width is 2px.
      // DistanceFromParentEdgeToButtonEdge - DistanceFrom3DotsEdgeToIconEdge
      //   = 10px - (ButtonWidth - 3DotsWidth) / 2
      //   = 10px - (32px - 2px) / 2
      //   = -5px
      '-end-1.25',
      // DistanceFromEdge - ImplicitTopPadding  = 10px - 8px = 2px
      'top-[-2px]' ],attrs:{"data-cy":"sectionAction","color-scheme":_vm.OzTextButtonColorScheme.SecondaryMuted,"dark-mode":_vm.colorScheme === 'dark',"aria-label":_vm.__('Section actions'),"title":_vm.__('Section actions')},on:{"click":function($event){return _vm.showSectionActionMenu({ sectionId: _vm.section.id })}}},[_c('OzIcon',{attrs:{"name":"more_vertical","size":16}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }